import type { SVGProps } from "react";
const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="translate(-1040 -80)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1045 86C1044.73 86 1044.48 86.1054 1044.29 86.2929C1044.11 86.4804 1044 86.7348 1044 87V97C1044 97.2652 1044.11 97.5196 1044.29 97.7071C1044.48 97.8946 1044.73 98 1045 98H1059C1059.27 98 1059.52 97.8946 1059.71 97.7071C1059.89 97.5196 1060 97.2652 1060 97V87C1060 86.7348 1059.89 86.4804 1059.71 86.2929C1059.52 86.1054 1059.27 86 1059 86H1045ZM1042.88 84.8787C1043.44 84.3161 1044.2 84 1045 84H1059C1059.8 84 1060.56 84.3161 1061.12 84.8787C1061.68 85.4413 1062 86.2043 1062 87V97C1062 97.7957 1061.68 98.5587 1061.12 99.1213C1060.56 99.6839 1059.8 100 1059 100H1045C1044.2 100 1043.44 99.6839 1042.88 99.1213C1042.32 98.5587 1042 97.7956 1042 97V87C1042 86.2044 1042.32 85.4413 1042.88 84.8787Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1042.17 86.4453C1042.47 85.9858 1043.1 85.8616 1043.55 86.1679L1052 91.7981L1060.45 86.1679C1060.9 85.8616 1061.53 85.9858 1061.83 86.4453C1062.14 86.9048 1062.01 87.5257 1061.55 87.8321L1052.55 93.8321C1052.22 94.056 1051.78 94.056 1051.45 93.8321L1042.45 87.8321C1041.99 87.5257 1041.86 86.9048 1042.17 86.4453Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export default SvgMail;
